import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ShareModule } from '../shared/share.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { VerificationComponent } from './verification.component';


@NgModule({
  declarations: [
    VerificationComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    ShareModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    VerificationComponent,
  ],
  providers: [],
})
export class VerificationModule { }